module.exports = __webpack_public_path__ + "img/icon-play.667099fc.png";